module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ls-4856aea205c94f19b9a335e48560ada4.svg";